import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import infoIco from 'assets/images/i-circle.svg';
import eye from 'assets/images/eye.png';
import hidden from 'assets/images/hidden.png';
import { Alert, Button, CloseButton, Modal, Tab, Tabs } from 'react-bootstrap';
import logo from 'assets/images/axlerate-logo.png';
// import logo from 'assets/images/eb-logo.svg';
import './styles.scss';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import api from 'api/client';
import LoginService from './services/login.service';
import Toast from 'shared/common/toast';
import { toast } from 'react-toastify';
import { userStore } from '../../store/UserStore';
import DashboardHttp from '../profile/services/profile.service';
import OtpWithTimer from 'shared/common/otpWithTimer/otpWithTimer';
import format from 'string-template';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  OTP_SENT_TO_EMAIL,
  OTP_SENT_TO_MOBILE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
} from 'constants/messages.constant';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import PasswordUpdate from './passwordUpdate';

interface PropsType {}

const Login: React.FC<PropsType> = () => {
  const indFormRef = useRef(null);
  const entFormRef = useRef(null);
  const [otpValue, setOtpValue] = useState<string>('');
  const [session, setSession] = useState(null);
  const [errorModal, setErrorModal] = useState<any>({});
  const [isOtpLogin, setIsOtpLogin] = useState<boolean>(false);
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isLoginError, setIsLoginError] = useState(false);
  const [enableResend, setEnableResend] = useState(false);
  const [mobile, setMobile] = useState('');
  const [values, setVal] = useState({});
  const history = useHistory();
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [countryCode, setCountryCode] = useState('+91');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isShowPwd, setShowPwd] = useState<boolean>(false);
  const { setLoginData } = userStore();
  const [pan, setPan] = useState('');
  const [key, setKey] = useState(sessionStorage.getItem('category') || 'b2c');
  const [email, setEmail] = useState('');
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [token, setToken] = useState(null);
  const [passwordUpdateObj, setPasswordUpdateObj] = useState({
    display: false,
    cognitoUser: null,
    userAttr: null,
  });
  const [setCustomerId, setCustomer, user, setUser] = userStore(
    (state: any) => [
      state.setCustomerId,
      state.setCustomer,
      state.user,
      state.setUser,
    ]
  );
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });

  useEffect(() => {
    document.title = 'Login - eBullion';
  }, []);

  useEffect(() => {
    sessionStorage.setItem('category', key);
  }, [key]);

  useEffect(() => {
    if (otpData.value?.length === 6) {
      verifyEmail ? onEmailOtpSuccess() : onSuccess();
    }
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const location = useLocation();
  let ID = new URLSearchParams(location.search).get('customerId');

  const getProfile = async (customerId: any) => {
    try {
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomer(userData.data.data.customer);
        history.push(new URLSearchParams(location.search).get('returnUrl'));
      }
    } catch (e: any) {
      //setLoading(false);
    }
  };

  const signIn = async (val, setFieldTouched, setFieldError, setFieldValue) => {
    setLoading(true);
    setMobile(countryCode + val.username);
    setVal(val);
    if (isOtpLogin) {
      if (!isOtpSent) {
        setFieldTouched('username', true);
        if (val.username && val.username.length === 10)
          sendMobileOtp(val, setFieldValue);
        else {
          setFieldError('username', 'Invalid mobile number');
        }
      } else {
        verifyMobileOtp(val);
      }
    } else {
      try {
        const res: any = await LoginService.login(
          countryCode + val.username,
          val.password
        );

        if (res) {
          if (res.changeRequired) {
            setPasswordUpdateObj({
              ...passwordUpdateObj,
              display: true,
              cognitoUser: res.user,
              userAttr: res.userAtr,
            });
          } else {
            setLoginData({
              customer: {},
              customerId: '',
              selectedAccount: {},
              user: {},
              tokens: {
                accessToken: res.getAccessToken(),
                idToken: res.getIdToken(),
                refreshToken: res.getRefreshToken(),
              },
              userData: res.getIdToken().decodePayload(),
            });
            api.setAuthAccess(res.accessToken.jwtToken);
            api.setAuthRefresh(res.refreshToken.token);
            api.setToken(res.idToken.jwtToken);

            if (ID) {
              setCustomerId(ID);
              getProfile(ID);
            }
            history.push('/customers');
          }
        }

        setLoading(false);
      } catch (err: any) {
        let error = JSON.parse(JSON.stringify(err));
        handleAwsErrors(error.code);
        setLoading(false);
      }
    }
  };
  const handlePasswordUpdateClose = () => {
    setPasswordUpdateObj({
      ...passwordUpdateObj,
      display: false,
      cognitoUser: null,
      userAttr: null,
    });
  };

  const entSignIn = async (val) => {
    setLoading(true);
    setVal(val);
    try {
      const res: any = await LoginService.entLogin(val.username, val.password);
      if (res) {
        if (!res.idToken.payload.email_verified) {
          setEmail(res.idToken.payload.email);
          setVerifyEmail(true);
          setToken(res);
        } else {
          setLoginData({
            customer: {},
            customerId: '',
            selectedAccount: {},
            user: {},
            tokens: {
              accessToken: res.getAccessToken(),
              idToken: res.getIdToken(),
              refreshToken: res.getRefreshToken(),
            },
            userData: res.getIdToken().decodePayload(),
          });
          api.setAuthAccess(res.accessToken.jwtToken);
          api.setAuthRefresh(res.refreshToken.token);
          api.setToken(res.idToken.jwtToken);
          if (ID) {
            setCustomerId(ID);
            getProfile(ID);
          }
          history.push('/accounts');
        }
      }
      setLoading(false);
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
    }
  };
  const handleAwsErrors = (errorCode) => {
    if (errorCode.includes('UserNotConfirmedException')) {
      setIsLoginError(true);
      setErrorModal({
        ...errorModal,
        title: 'Account Verification Pending',
        message:
          'Your account is not verified yet. An OTP will be sent to your registered mobile number.',
        type: 'warn',
      });
      return toast.error('Please verify your mobile number');
    }
    if (errorCode.includes('userNotFound')) {
      return toast.error('User with given phone number does not exist');
    }
    if (errorCode.includes('NewPasswordRequiredException')) {
      return toast.error(
        'You need to login with temporary password and set new password first.',
        {
          autoClose: false,
        }
      );
    }
    switch (errorCode) {
      case 'UserNotConfirmedException':
        setIsLoginError(true);
        setErrorModal({
          ...errorModal,
          title: 'Account Verification Pending',
          message:
            'Your account is not verified yet. An OTP will be sent to your registered mobile number.',
          type: 'warn',
        });
        toast.error('Please verify your mobile number');
        break;
      case 'ExpiredCodeException':
        toast.error('Verification code expired');
        break;
      case 'NotAuthorizedException':
        !isOtpLogin
          ? toast.error('Invalid Username or Password')
          : toast.error('OTP entered is incorrect');
        break;
      case 'CodeMismatchException':
        toast.error('Please enter valid verification code');
        break;

      default:
        toast.error('Somthing went wrong');
        break;
    }
  };

  const sendOtp = async () => {
    setLoading(true);
    try {
      const res: any =
        key === 'b2c'
          ? await LoginService.sendOTP(mobile)
          : await LoginService.entSendOTP(pan);
      setLoading(false);
      if (res) {
        setModalShow(true);
        setIsLoginError(false);
      }
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
      toast.error('Something went wrong, Please try again later');
    }
  };
  const sendMobileOtp = async (values: any, setFieldValue) => {
    if (values.username) {
      setLoading(true);
      setMobile(`+91${values.username}`);
      try {
        const res: any = await LoginService.generateLoginOtp(
          `+91${values.username}`
        );

        setLoading(false);

        if (res) {
          setFieldValue('isOtpSent', true);
          setSession(res);
          setIsOtpSent(true);
        }
      } catch (error: any) {
        handleAwsErrors(error.toString());
        setFieldValue('isOtpSent', false);
        setLoading(false);
      }
    }
  };

  const verifyMobileOtp = async (values: any) => {
    if (values.username && values.otp) {
      setLoading(true);
      try {
        const res: any = await LoginService.verifyLoginOtp(session, values.otp);

        setLoading(false);
        if (res.signInUserSession) {
          api.setAuthAccess(res.signInUserSession.accessToken.jwtToken);
          api.setAuthRefresh(res.signInUserSession.refreshToken.token);
          api.setToken(res.signInUserSession.idToken.jwtToken);
          history.push('/customers');
        } else {
          toast.error('OTP entered is incorrect');
        }
      } catch (err) {
        let error = JSON.parse(JSON.stringify(err));
        handleAwsErrors(error.code);
        setLoading(false);
      }
    }
  };

  const onSuccess = async () => {
    setLoading(true);
    try {
      const res: any =
        key === 'b2c'
          ? await LoginService.verifyOTP(mobile, otpData?.value)
          : await LoginService.verifyEntOTP(pan, otpData?.value);
      // const res: any = await LoginService.verifyOTP(mobile, otpData?.value);
      setLoading(false);
      if (res) {
        setOtpData({
          ...otpData,
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success(
          'User account is now verified. Please login with your credentials.'
        );
        setModalShow(false);
      }
    } catch (err: any) {
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      setLoading(false);
      toast.error(err.message);
    }
  };

  const sendOtpThroughMail = async () => {
    setLoading(true);
    try {
      //update user email
      // const email_res: any = await LoginService.updateUser(
      //   token.idToken.payload.sub,
      //   { email: { value: email, isVerified: false } },
      //   token.idToken.jwtToken
      // );

      //sent otp for mail
      const res: any = await LoginService.sendOTPToEmail(
        token.idToken.jwtToken,
        token.accessToken.jwtToken
      );

      setLoading(false);

      if (res) {
        resetOtpData();
        setModalShow(true);
      }
    } catch (err: any) {
      setLoading(false);

      if (err) {
        toast.error(err.data.errors[0].title);
      } else {
        toast.error('Something went wrong');
      }
    }
  };

  const onEmailOtpSuccess = async () => {
    try {
      setLoading(true);
      const res: any = await LoginService.verifyB2bUser(
        { code: otpData.value },
        token.idToken.jwtToken,
        token.accessToken.jwtToken
      );
      setLoading(false);
      if (res) {
        entSignIn(values);
      }
    } catch (err: any) {
      setLoading(false);
      console.log(err);
      toast.error(err.data.errors[0].title);
    }
  };

  return (
    <div>
      <Toast />
      <PasswordUpdate
        show={passwordUpdateObj.display}
        cognitoUser={passwordUpdateObj.cognitoUser}
        userData={passwordUpdateObj.userAttr}
        onClose={handlePasswordUpdateClose}
      />
      <OtpPopup
        show={modalShow}
        isLoading={isLoading}
        handleClose={() => {
          resetOtpData();
          setModalShow(false);
        }}
        modalTitle={`Account Verification`}
        modalSubmitBtnText='Verify'
        onSubmit={() => (verifyEmail ? onEmailOtpSuccess() : onSuccess())}
        otpLabel={
          verifyEmail
            ? OTP_SENT_TO_EMAIL
            : key === 'b2c'
            ? format(OTP_SENT_TO_REG_MESSAGE, {
                suffixDigits: mobile?.slice(-4),
              })
            : OTP_SENT_TO_MOBILE
        }
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          verifyEmail ? sendOtpThroughMail() : sendOtp();
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />

      <Modal
        show={isLoginError}
        onHide={() => setIsLoginError(false)}
        // backdrop='static'
        keyboard={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header>
          <div className='d-flex w-100 justify-content-between align-items-center'>
            {errorModal?.title && (
              <h4 className='text-center my-1'>{errorModal?.title}</h4>
            )}
            <CloseButton onClick={() => setIsLoginError(false)}></CloseButton>
          </div>
        </Modal.Header>
        <Modal.Body>
          {errorModal?.message && (
            <p className='h6 text-center mx-5 my-2'>{errorModal?.message}</p>
          )}
          <div className='text-center'>
            <Button
              className='w-50 mt-3'
              variant='primary'
              onClick={() => sendOtp()}
            >
              Get OTP
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className='login-wrapper'>
        <div className='login-banner d-none d-sm-block d-sm-flex'>
          {/* <img src={logo} alt='' /> */}
        </div>
        {!verifyEmail ? (
          <div className='login-form'>
            <div className='login-form-group'>
              <div className='mt-0 my-5 d-sm-block d-md-none'>
                <img src={logo} alt='' />
              </div>
              <div className='title'>
                <h3>Sign in to your account</h3>
                <p>
                  Sign in to your account and start your eBullion journey today
                </p>
              </div>
              <Tabs
                id='controlled-tab-example'
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  if (k == 'b2c') indFormRef.current.resetForm();
                  else entFormRef.current.resetForm();

                  sessionStorage.setItem('category', k);
                }}
                className='mb-3'
              >
                <Tab eventKey='b2c' title='Individual'>
                  <>
                    <Formik
                      innerRef={indFormRef}
                      initialValues={{
                        isOtp: false,
                        isOtpSent: false,
                        username: '',
                        password: '',
                        otp: '',
                      }}
                      onSubmit={(
                        values,
                        {
                          setSubmitting,
                          resetForm,
                          setFieldTouched,
                          setFieldError,
                          setFieldValue,
                        }
                      ) => {
                        setSubmitting(false);
                        signIn(
                          values,
                          setFieldTouched,
                          setFieldError,
                          setFieldValue
                        );
                      }}
                      validationSchema={Yup.object().shape({
                        isOtp: Yup.boolean(),
                        isOtpSent: Yup.boolean(),
                        username: Yup.string()
                          .min(10, 'Invalid mobile number')
                          .max(10, 'Invalid mobile number')
                          .required('Invalid mobile number'),
                        password: Yup.string().when('isOtp', {
                          is: false,
                          then: Yup.string().required('Field is required'),
                          otherwise: Yup.string(),
                        }),
                        otp: Yup.string().when('isOtp', {
                          is: true,
                          then: Yup.string().when('isOtpSent', {
                            is: true,
                            then: Yup.string().required('Please enter OTP'),
                            otherwise: Yup.string(),
                          }),
                          otherwise: Yup.string(),
                        }),
                      })}
                    >
                      {({
                        isSubmitting,
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        setFieldTouched,
                        setFieldError,
                        validateField,
                      }) => (
                        <Form translate={undefined}>
                          <div className='form-group mb-2'>
                            <label className='form-label'>Mobile</label>
                            <div className='input-group mb-3'>
                              <div
                                className='input-group-text'
                                id='basic-addon1'
                              >
                                <select
                                  className='form-control country-select'
                                  onChange={(event) =>
                                    setCountryCode(event.target.value)
                                  }
                                  value={countryCode}
                                >
                                  <option value={'+91'}>+91</option>
                                </select>
                              </div>
                              <Field
                                type='text'
                                placeholder=''
                                name='username'
                                className='form-control'
                                disabled={isOtpLogin && isOtpSent}
                                onChange={(e) => {
                                  if (
                                    e.target.value.length > 10 ||
                                    /[^0-9]/.test(e.target.value)
                                  )
                                    return;
                                  setFieldValue('username', e.target.value);
                                }}
                              />
                            </div>
                            <div className='error'>
                              {errors.username && touched.username && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.username}
                                </small>
                              )}
                            </div>
                            <Field
                              type='text'
                              placeholder=''
                              name='isOtp'
                              className='form-control'
                              hidden
                            />
                          </div>

                          {!isOtpLogin ? (
                            <>
                              <div className='form-group mb-2'>
                                <label className='form-label'>Password</label>
                                <div className='input-group mb-3'>
                                  <Field
                                    type={isShowPwd ? 'text' : 'password'}
                                    placeholder='Password'
                                    name='password'
                                    style={{ position: 'unset' }}
                                    className='form-control'
                                  />
                                  <div
                                    className='input-group-text'
                                    id='basic-addon1'
                                    style={{
                                      border: '1px solid #ced4da',
                                      borderLeft: '0px',
                                      backgroundColor: 'white',
                                      borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                    }}
                                  >
                                    <a
                                      href='#'
                                      onClick={() => setShowPwd(!isShowPwd)}
                                    >
                                      <img
                                        className='m-2'
                                        style={{ width: '16px' }}
                                        src={isShowPwd ? hidden : eye}
                                        alt=''
                                      />
                                    </a>
                                  </div>
                                </div>

                                <div className='error'>
                                  {errors.password && touched.password && (
                                    <small id='my-helper-text'>
                                      <img src={infoIco} alt='' />
                                      {errors.password}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className='form-group mb-2 fp'>
                                <a
                                  onClick={(e) =>
                                    history.push('/reset-password')
                                  }
                                  href='#'
                                >
                                  Forgot Password ?
                                </a>
                              </div>
                            </>
                          ) : (
                            isOtpSent && (
                              <>
                                <OtpWithTimer
                                  enableResendTimer
                                  resendInterval={30}
                                  numInputs={6}
                                  otpLabel='Please enter OTP'
                                  otpChangeHandler={(value) => {
                                    setOtpValue(value);
                                    setFieldValue('otp', value);
                                    if (value?.length === 6)
                                      signIn(
                                        {
                                          ...values,
                                          otp: value,
                                        },
                                        setFieldTouched,
                                        setFieldError,
                                        setFieldValue
                                      );
                                  }}
                                  isCentered
                                  otpValue={otpValue}
                                  resendButtonText='Resend OTP'
                                  ackMessage='OTP has been sent to your registered mobile number.'
                                  ackMessageType='success'
                                  resendHandler={() =>
                                    sendMobileOtp(values, setFieldValue)
                                  }
                                ></OtpWithTimer>
                                <div className='text-end error'>
                                  {errors.otp && touched.otp && (
                                    <small id='my-helper-text'>
                                      <img src={infoIco} alt='' />
                                      {errors.otp}
                                    </small>
                                  )}
                                </div>
                              </>
                            )
                          )}

                          <div className='form-group mb-2'>
                            <label className='form-label'>
                              <Field
                                type='checkbox'
                                placeholder=''
                                name='otp_checkbox'
                                checked={isOtpLogin}
                                onChange={(e) => {
                                  setIsOtpLogin(e.target.checked);
                                  setIsOtpSent(false);
                                  setFieldValue('isOtpSent', false);
                                  setFieldValue('isOtp', e.target.checked);
                                }}
                                className='mx-1'
                              />
                              Sign in with OTP
                            </label>
                          </div>

                          {!isOtpLogin ? (
                            <Button
                              disabled={isLoading}
                              className='w-100 mt-3'
                              variant='primary'
                              type='submit'
                            >
                              {!isLoading ? (
                                'Sign in'
                              ) : (
                                <div
                                  className='spinner-border text-white'
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </Button>
                          ) : !isOtpSent ? (
                            <Button
                              type='submit'
                              disabled={isLoading}
                              className='w-100 mt-3'
                              variant='primary'
                            >
                              {!isLoading ? (
                                'Request OTP'
                              ) : (
                                <div
                                  className='spinner-border text-white'
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </Button>
                          ) : (
                            <Button
                              disabled={isLoading}
                              className='w-100 mt-3'
                              variant='primary'
                              type='submit'
                            >
                              {!isLoading ? (
                                'Verify OTP'
                              ) : (
                                <div
                                  className='spinner-border text-white'
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </Button>
                          )}
                        </Form>
                      )}
                    </Formik>
                    <div className='text-center sign-in-text justify-content-between'>
                      {/* <div className='link-container'> */}
                      <a onClick={(e) => history.push('/signup')}>
                        New to eBullion ? <span>Open account</span>
                      </a>
                      <br />
                      Need help?
                      <a
                        href='https://ebullion.in/contact-us'
                        style={{ fontSize: '14px', textDecoration: 'none' }}
                      >
                        {' '}
                        <span>Click Here</span>
                      </a>
                      {/* </div> */}
                    </div>
                  </>
                </Tab>
                <Tab eventKey='b2b' title='Enterprise'>
                  <>
                    <Formik
                      innerRef={entFormRef}
                      initialValues={{
                        isOtp: false,
                        username: '',
                        password: '',
                      }}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(false);
                        entSignIn(values);
                      }}
                      validationSchema={Yup.object().shape({
                        isOtp: Yup.boolean(),
                        username: Yup.string()
                          .matches(
                            /^[A-Z0-9]+$/,
                            'Special characters are not allowed'
                          )
                          .trim('PAN is invalid')
                          .required('PAN is required'),
                        password: Yup.string().when('isOtp', {
                          is: false,
                          then: Yup.string().required('Field is required'),
                          otherwise: Yup.string(),
                        }),
                      })}
                    >
                      {({
                        isSubmitting,
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        setFieldTouched,
                        setFieldError,
                        validateField,
                      }) => (
                        <Form translate={undefined}>
                          <div className='form-group mb-2'>
                            <label className='form-label'>
                              Permanent Account Number (PAN)
                            </label>
                            <div className='input-group mb-3'>
                              <Field
                                type='text'
                                placeholder=''
                                name='username'
                                className='form-control'
                                disabled={isOtpLogin && isOtpSent}
                                onChange={(e) => {
                                  if (
                                    e.target.value.length > 10 ||
                                    !/^[a-zA-Z0-9]*$/.test(e.target.value)
                                  )
                                    return;
                                  setFieldValue(
                                    'username',
                                    e.target.value?.toUpperCase()
                                  );
                                  setPan(e.target.value?.toUpperCase());
                                }}
                              />
                            </div>
                            <div className='error'>
                              {errors.username && touched.username && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.username}
                                </small>
                              )}
                            </div>
                            <Field
                              type='text'
                              placeholder=''
                              name='isOtp'
                              className='form-control'
                              hidden
                            />
                          </div>

                          <>
                            <div className='form-group mb-2'>
                              <label className='form-label'>Password</label>
                              <div className='input-group mb-3'>
                                <Field
                                  type={isShowPwd ? 'text' : 'password'}
                                  placeholder='Password'
                                  name='password'
                                  style={{ position: 'unset' }}
                                  className='form-control'
                                />
                                <div
                                  className='input-group-text'
                                  id='basic-addon1'
                                  style={{
                                    border: '1px solid #ced4da',
                                    borderLeft: '0px',
                                    backgroundColor: 'white',
                                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                  }}
                                >
                                  <a
                                    href='#'
                                    onClick={() => setShowPwd(!isShowPwd)}
                                  >
                                    <img
                                      className='m-2'
                                      style={{ width: '16px' }}
                                      src={isShowPwd ? hidden : eye}
                                      alt=''
                                    />
                                  </a>
                                </div>
                              </div>

                              <div className='error'>
                                {errors.password && touched.password && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.password}
                                  </small>
                                )}
                              </div>
                            </div>

                            <div className='form-group mb-2 fp'>
                              <a
                                onClick={(e) =>
                                  history.push('/ent-reset-password')
                                }
                                href='#'
                              >
                                Forgot Password ?
                              </a>
                            </div>
                          </>

                          <Button
                            disabled={isLoading}
                            className='w-100 mt-3'
                            variant='primary'
                            type='submit'
                          >
                            {!isLoading ? (
                              'Sign in'
                            ) : (
                              <div
                                className='spinner-border text-white'
                                role='status'
                              >
                                <span className='visually-hidden'>
                                  Loading...
                                </span>
                              </div>
                            )}
                          </Button>
                        </Form>
                      )}
                    </Formik>
                    {/* <div className='text-center sign-in-text'> */}
                    <div className='text-center sign-in-text justify-content-between'>
                      <a onClick={(e) => history.push('/enterprise')}>
                        Own a business ? <span>Open enterprise account</span>{' '}
                      </a>
                      <br></br>
                      Need help?
                      <a
                        href='https://ebullion.in/contact-us'
                        style={{ fontSize: '14px', textDecoration: 'none' }}
                      >
                        {' '}
                        <span>Click Here</span>
                      </a>
                    </div>
                  </>
                </Tab>
              </Tabs>
            </div>
          </div>
        ) : (
          <div className='login-form'>
            <div className='login-form-group'>
              <div className='mt-0 my-5 d-sm-block d-md-none'>
                <img src={logo} alt='' />
              </div>
              <div className='title'>
                <h3>Thank you for signing in!</h3>
                <p>Verify your email account</p>
              </div>
              <Formik
                enableReinitialize
                initialValues={{ email: email }}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(false);
                  sendOtpThroughMail();
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().required('Email is required'),
                })}
              >
                {({ isSubmitting, errors, touched, setFieldValue }) => (
                  <Form translate={undefined}>
                    <div className='form-group mb-2'>
                      <label className='form-label'>Email</label>
                      <Field
                        type='text'
                        name='email'
                        className='form-control'
                        value={email}
                        disabled
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setFieldValue('email', e.target.value);
                        }}
                      />
                      <div className='error'>
                        {errors.email && touched.email && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.email}
                          </small>
                        )}
                      </div>
                    </div>
                    <Button
                      disabled={isLoading}
                      className='w-100 mt-3'
                      variant='primary'
                      type='submit'
                    >
                      {!isLoading ? (
                        'Verify'
                      ) : (
                        <div
                          className='spinner-border text-white'
                          role='status'
                        >
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                      )}
                    </Button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
